import { render, staticRenderFns } from "./Create-Contract.vue?vue&type=template&id=95578624&scoped=true"
import script from "./Create-Contract.vue?vue&type=script&lang=js"
export * from "./Create-Contract.vue?vue&type=script&lang=js"
import style0 from "./Create-Contract.vue?vue&type=style&index=0&id=95578624&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95578624",
  null
  
)

export default component.exports